/** Figma `Tooltip` 세트(Components, 32:417) */
export const TOOLTIP_TONES = ['light', 'dark'] as const;
export type TooltipTone = (typeof TOOLTIP_TONES)[number];

export const TOOLTIP_PLACEMENTS = ['top', 'bottom', 'left', 'right'] as const;
export type TooltipPlacement = (typeof TOOLTIP_PLACEMENTS)[number];

/**
 * 말풍선. light(기준) = 흰 면 + 옅은 테두리 + 모서리 10 + 그림자, dark = 검은 면 + 모서리 4(차트 · 표).
 * 위아래 6(raw 예외)은 `py-1`(4) + 글자 칸의 투명 테두리 2(`TOOLTIP_CONTENT_CLASS`)로 낸다.
 */
export const TOOLTIP_BUBBLE_CLASS: Record<TooltipTone, string> = {
  light: 'rounded-xl border border-border-default bg-bg-surface text-fg-default shadow-subtle',
  dark: 'rounded-sm bg-bg-inverse text-fg-inverse',
};

export const TOOLTIP_CONTENT_CLASS = 'flex flex-col gap-1 border-y-2 border-transparent';

/** 말풍선과 꼭지를 늘어놓는 방향(DOM 순서는 말풍선 → 꼭지) */
export const TOOLTIP_LAYOUT_CLASS: Record<TooltipPlacement, string> = {
  top: 'flex-col',
  bottom: 'flex-col-reverse',
  left: 'flex-row',
  right: 'flex-row-reverse',
};

/** 꼭지(dark 만). 12×6, 말풍선에서 기준 요소 쪽을 가리킨다 */
export const TOOLTIP_ARROW: Record<
  TooltipPlacement,
  { width: number; height: number; points: string }
> = {
  top: { width: 12, height: 6, points: '0,0 12,0 6,6' },
  bottom: { width: 12, height: 6, points: '0,6 12,6 6,0' },
  left: { width: 6, height: 12, points: '0,0 0,12 6,6' },
  right: { width: 6, height: 12, points: '6,0 6,12 0,6' },
};

/** inline 으로 기준 요소 옆에 붙일 때의 자리 */
export const TOOLTIP_INLINE_POSITION_CLASS: Record<TooltipPlacement, string> = {
  top: 'bottom-full left-1/2 mb-1 -translate-x-1/2',
  bottom: 'top-full left-1/2 mt-1 -translate-x-1/2',
  left: 'top-1/2 right-full mr-1 -translate-y-1/2',
  right: 'top-1/2 left-full ml-1 -translate-y-1/2',
};

/** portal 로 띄울 때 기준 요소와의 간격(px, space/1) */
export const TOOLTIP_OFFSET_PX = 4;
